import { Link } from "react-router-dom";
import Slide from "react-reveal/Slide";

export const InventoryHeroComp = () => {
  return (
    <section className="relative overflow-hidden min-h-screen bg-slate-950 text-white">

      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-15"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/site/banner1.jpg)`,
        }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-red-950 to-black" />

      {/* Decorative Blur */}
      <div className="absolute -left-32 top-0 h-[450px] w-[450px] rounded-full bg-red-600/20 blur-[150px]" />

      <div className="absolute right-0 bottom-0 h-[500px] w-[500px] rounded-full bg-orange-500/15 blur-[180px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">

        <div className="min-h-screen flex items-center">

          <div className="grid lg:grid-cols-2 gap-20 items-center w-full">

            {/* LEFT */}

            <Slide left>

              <div>

                {/* Badge */}

                <div className="inline-flex items-center gap-3 rounded-full border border-red-500/30 bg-red-500/10 px-5 py-2 backdrop-blur-lg">

                  <span className="h-2 w-2 rounded-full bg-red-400 animate-pulse" />

                  <span className="text-sm text-red-300 font-medium">
                    Trusted Inventory Management Software
                  </span>

                </div>

                {/* Heading */}

                <h1 className="mt-8 text-5xl sm:text-6xl lg:text-7xl font-black leading-tight">

                  Manage Your

                  <span className="block bg-gradient-to-r from-red-500 via-orange-400 to-yellow-300 bg-clip-text text-transparent">

                    Business Smarter

                  </span>

                </h1>

                <p className="mt-8 text-xl leading-9 text-slate-300 max-w-2xl">

                  Increase sales, eliminate stock shortages, manage warehouses,
                  automate purchases, monitor inventory in real-time and grow
                  your business with one powerful cloud platform.

                </p>

                {/* Features */}

                <div className="mt-10 grid grid-cols-2 gap-5 text-slate-300">

                  <div className="flex items-center gap-3">

                    ✅ Real-time Stock

                  </div>

                  <div className="flex items-center gap-3">

                    ✅ Sales Tracking

                  </div>

                  <div className="flex items-center gap-3">

                    ✅ Purchase Orders

                  </div>

                  <div className="flex items-center gap-3">

                    ✅ Multi Warehouse

                  </div>

                </div>

                {/* CTA */}

                <div className="mt-12 flex flex-wrap gap-5">

                  <a
                    href="https://admin.suparecords.ng/auth/signup"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 px-10 py-4 font-semibold shadow-xl transition hover:scale-105 hover:shadow-red-500/40"
                  >
                    Start Free →
                  </a>

                  <Link
                    to="/contact"
                    className="rounded-2xl border border-white/15 bg-white/5 px-10 py-4 backdrop-blur-lg hover:bg-white/10 transition"
                  >
                    Book Demo
                  </Link>

                </div>

                {/* Stats */}

                <div className="mt-16 grid grid-cols-3 gap-8">

                  <div>

                    <h2 className="text-4xl font-black text-red-400">
                      99.9%
                    </h2>

                    <p className="mt-2 text-slate-400">
                      Uptime
                    </p>

                  </div>

                  <div>

                    <h2 className="text-4xl font-black text-red-400">
                      24/7
                    </h2>

                    <p className="mt-2 text-slate-400">
                      Support
                    </p>

                  </div>

                  <div>

                    <h2 className="text-4xl font-black text-red-400">
                      Cloud
                    </h2>

                    <p className="mt-2 text-slate-400">
                      Access
                    </p>

                  </div>

                </div>

              </div>

            </Slide>

            {/* RIGHT */}

            <Slide right>

              <div className="relative flex justify-center">

                <div className="absolute h-[450px] w-[450px] rounded-full bg-red-600/20 blur-[120px]" />

                <img
                  src={`${process.env.PUBLIC_URL}/images/site/bannere.png`}
                  alt="Inventory Dashboard"
                  className="relative z-10 w-full max-w-3xl rounded-3xl border border-white/10 shadow-[0_40px_100px_rgba(0,0,0,.5)]"
                />

                {/* Floating Card */}

                <div className="absolute left-0 top-12 rounded-3xl border border-white/10 bg-white/10 backdrop-blur-xl p-5 shadow-2xl">

                  <p className="text-slate-300 text-sm">
                    Inventory
                  </p>

                  <h3 className="text-3xl font-black">
                    18,540
                  </h3>

                  <p className="text-green-400">
                    ▲ +12.6%
                  </p>

                </div>

                {/* Floating Card */}

                <div className="absolute right-0 bottom-16 rounded-3xl border border-white/10 bg-white/10 backdrop-blur-xl p-5 shadow-2xl">

                  <p className="text-slate-300 text-sm">
                    Orders Today
                  </p>

                  <h3 className="text-3xl font-black">
                    428
                  </h3>

                  <p className="text-orange-400">
                    Processing
                  </p>

                </div>

              </div>

            </Slide>

          </div>

        </div>

        {/* Scroll Indicator */}

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex">

          <div className="flex h-12 w-7 justify-center rounded-full border border-white/30">

            <div className="mt-2 h-3 w-3 rounded-full bg-red-400 animate-bounce" />

          </div>

        </div>

      </div>

    </section>
  );
};

export default InventoryHeroComp;